import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { environment } from '@environments/environment';
import { Observable } from 'rxjs';
import type {
  ListFormSubmissionsApiResponse,
  ListFormSubmissionsParams,
} from '../models/list-form-submissions';

@Injectable({ providedIn: 'root' })
export class FormSubmissionsApiService {
  private readonly http = inject(HttpClient);

  listFormSubmissions(
    slug: string,
    params?: ListFormSubmissionsParams,
  ): Observable<ListFormSubmissionsApiResponse> {
    let httpParams = new HttpParams();
    if (params?.page != null) {
      httpParams = httpParams.set('page', String(params.page));
    }
    if (params?.limit != null) {
      httpParams = httpParams.set('limit', String(params.limit));
    }

    return this.http.get<ListFormSubmissionsApiResponse>(
      `${environment.baseUrl}/forms/${encodeURIComponent(slug)}/submissions`,
      { params: httpParams },
    );
  }
}
